export function sameSlot(left, right) {
  return (left?.appId || null) === (right?.appId || null)
    && Boolean(left?.allApps) === Boolean(right?.allApps)
    && (left?.platform || "") === (right?.platform || "");
}

export function sameDateRange(left, right) {
  return (left?.from || "") === (right?.from || "")
    && (left?.to || "") === (right?.to || "");
}

export function hasDashboardFilterChanges(draft, applied) {
  return !sameSlot(draft.slotA, applied.slotA)
    || !sameSlot(draft.slotB, applied.slotB)
    || Boolean(draft.compareMode) !== Boolean(applied.compareMode);
}

export function isSlotSelectionValid(slot, allowAllApps = false) {
  if (allowAllApps && slot?.allApps) return true;
  return Boolean(slot?.appId && slot?.platform);
}

export function isDashboardTargetValid({ slotA, slotB, compareMode, allowAllApps = false }) {
  if (!isSlotSelectionValid(slotA, allowAllApps)) return false;
  return !compareMode || isSlotSelectionValid(slotB, false);
}
